module.exports = __webpack_public_path__ + "img/iconeVendas.a3c6a8de.png";